export const DEFAULT_CODE = 'AAA';

export const RECOMMENDATIONS = {
  BUY: 'BUY',
  SELL: 'SELL',
  NEU: 'NEU',
  HOLD: 'HOLD',
  NOCMT: 'NOCMT',
};
